import { render, staticRenderFns } from "./ChartReport.vue?vue&type=template&id=f35a5d38&scoped=true"
import script from "./ChartReport.vue?vue&type=script&lang=js"
export * from "./ChartReport.vue?vue&type=script&lang=js"
import style0 from "./ChartReport.vue?vue&type=style&index=0&id=f35a5d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35a5d38",
  null
  
)

export default component.exports